import { useState } from 'react'
import { classNames, Spinner, apiClient } from '../utils/helpers';
import Countdown from 'react-countdown';

import {
  CheckIcon,
} from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

export default function VerifyEmail(props) {

  const { t } = useTranslation();
  const [form, setForm] = useState(
    {
      email:''
    });
  const [error,setError] = useState('');
  const [otpSent,setOtpSent] = useState(false);
  const [otpLock, setOtpLock] = useState(false);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const otpCountdown = 60000

  const countdown = ({ hours, minutes, seconds, completed }) => {
    if (completed) {      
      setOtpLock(false)
    } else {      
      return <span>{seconds}</span>;
    }
  };

  function checkCanSend()
  {
    if(!form.email) {
      setError('email_required');
    } else {
      if(props.checkUser) {
        
        apiClient.post(`/api/check_email`,{
          email: form.email
        })
        .catch(function(err){
          setError(err.response.data.message)
        })
        .then((response) => {
          if(response.data.customer && response.data.customer === true) {
            sendOtp();
          } else {
            setError('email_format_error')
          }
        })    

      } else {
        sendOtp();
      }
    }    
  }

  function sendOtp() {    

    setOtpLock(true)
    setError(false)
    setOtpSent(form.email)
    
    apiClient.post(`/api/send_email`,{      
      email: form.email
    })
    .catch(function(err){
      setError(err.response.data.message)
    })
    .then((response) => {
      
    })    

  }

  async function verifyOtp() {
    setLoading(true)
    
    apiClient.post(`/api/verify_otp`,{
      code: form.code,
      to: otpSent,
      type: 'email'
    })
    .catch(function(err){
      setError(err.response.data.message)
    })
    .then((response) => {
      
      if(response && response.data.status === 'approved') {
        
        setVerified(true)            

        if(props.setEmail) {
          props.setEmail(form.email)
        }
        props.setOtpVerified(true)  

      } else {
        setError('Invalid Email code. Please try again.')
      }
    })
    .finally(() => {
      setLoading(false)
    }) 
    
  }

  return (
    <div className="flex flex-col">
      <label className="font-bold">{t('your_email_address')}</label>
      <div className="text-sm font-medium text-gray-500">
        <span dangerouslySetInnerHTML={{__html: t('email_otp_notice') }}/>
      </div>

      <div className="flex flex-col gap-3 mt-1 mb-3">
        
        <input type="text" value={form.email} onChange={(e) => setForm({...form,email: e.target.value})} placeholder={t('your_email_address')} className="w-full md:w-auto"/>
        <button disabled={otpLock ? true : ""} onClick={() => checkCanSend() } className={classNames(otpLock ? "bg-gray-500":"bg-[#8B8444]","w-full md:w-auto text-sm font-bold opacity-90 hover:opacity-100 p-3 px-4 rounded-lg")}>
          {
            !otpLock ?
            t('send_email_otp')
            :
            <Countdown date={Date.now() + otpCountdown} renderer={countdown}/>
          }
        </button>
      </div>      
      {
        otpSent !== false &&
        <>
          <label className="block mb-3 leading-tight text-sm font-medium text-green-500">{t('verify_email_otp')}</label>
          <div className="flex mt-1 gap-3">                  
            <input type="number" value={form.code} onChange={(e) => setForm({...form,code: e.target.value})} placeholder={t('email_code')} className="w-[120px]" />
            <button disabled={loading || verified ? true : ''} onClick={() => verifyOtp() } 
              className={classNames(loading ? "bg-gray-500": (verified ? "" : "bg-[#8B8444] opacity-90 hover:opacity-100"),"text-sm font-bold p-3 px-4 rounded-lg")}>
              {
                loading ?
                <>
                  <Spinner />
                </>
                :
                <>
                  {
                    !verified ? t('verify_otp')                    
                    :
                    <div className="flex gap-1 text-green-500">
                      <CheckIcon className="w-5"/> {t('verify_success')}
                    </div>
                  }
                </>
              }
            </button>
          </div>
        </>
      }
      {
        error &&
        <div className="text-red-500 mb-5">{t(error)}</div>
      }
    </div>
  );
}